import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {ISearchAPIResponse} from "../types/ISearchAPIResponse";

export const getSearchByFriendlySlugApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getSearchByFriendlySlug: build.query<ISearchAPIResponse, {friendlySlug: string}>({
            query: ({friendlySlug}) => apiLink.search.search({})({friendlySlug}),
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetSearchByFriendlySlugQuery, useLazyGetSearchByFriendlySlugQuery} = getSearchByFriendlySlugApi;
